import fetch, { baseUrl } from '../utils/fetch'




/**
 * 获取图形验证码
 */
export const CAPTCHA_URL = `${baseUrl}/enterprise/captcha/`

/**
 * 获取验证码
 */
export const getSmsCode = (imgCode, phone, ticket, randstr, timestamp) => fetch('/enterprise/wechat/code', {
  source: 'WEB',
  imgCode: imgCode,
  phone: phone,
  ticket: ticket,
  randstr: randstr,
  t: timestamp
}, 'POST')


/**
 * 账号密码登录
 */
export const loginByPwd = data => fetch('/enterprise/loginByAliCode', data, 'POST')


/**
 * 注册
 */
export const register = data => fetch('/enterprise/register', data, 'POST')

/**
 * 手机验码登录
 */
export const loginByCode = data => fetch('/enterprise/loginByPhoneAndAliCode', {
  phone: data.account,
  code: data.password,
  sessionId: data.sessionId,
  sig: data.sig,
  token: data.token,
  scene: data.scene
}, 'POST')

/**
 * 获取用户信息
 */
export const getUserInfo = () => fetch('/enterprise/userInfo/getUserInfo')

/**
 * 开庭统计
 */
export const courtStatistics = () => fetch('/enterprise/batchCase/meeting/statistics')

/**
 * 开庭列表
 */
export const courtList = data => fetch('/enterprise/batchCase/meeting/list', data, 'POST')

/**
 * 开庭统计
 */
export const signStatistics = () => fetch('/enterprise/batchCase/meeting/record/statistics')

/**
 * 签名列表
 */
export const signList = data => fetch('/enterprise/batchCase/meeting/record/list', data, 'POST')

/**
 * 案件详情
 */
export const caseInfo = id => fetch(`/enterprise/batchCase/meeting/detail/${id}`)

/**
 * 邀请码获取房间号
 */
export const getVideoCallRoomId = code => fetch(`/enterprise/batchCase/meeting/inviteCode?inviteCode=${code}`)

/**
 * 获取视频签名
 */
export const getVideoSign = () => fetch('/enterprise/batchCase/tencent/video/sign')

/**
 * 获取小程序二维码
 */
export const getMiniCode = data => fetch('/enterprise/batchCase/code/gen', data, 'POST')

/**
 * 获取小程序二维码进度
 */
export const getMiniCodeProgress = id => fetch('/enterprise/batchCase/code/progress?uid=' + id)

/**
 * 语音识别
 */
export const asr = data => fetch('/enterprise/wechat/realtime', data, 'upload')

/**
 * 上传文件
 */
export const uploadFile = data => fetch('/enterprise/user/normalCaseFile/uploadFile', data, 'upload')

/**
 * 案件材料上传
 */
export const uploadCaseFile = data => fetch('/enterprise/batchCase/meeting/file', data, 'POST')

/**
 * 获取我的笔录
 */
export const meCourtRecord = id => fetch(`/enterprise/batchCase/meeting/self/${id}`)

/**
 * 获取我的笔录
 */
export const refreshRecord = data => fetch('/enterprise/batchCase/record/refresh', data, 'POST')

/**
 * 保存ai内容
 */
export const saveAiText = data => fetch('/enterprise/batchCase/meeting/ai/record', data, 'POST')

/**
 * 获取AI内容
 */
export const aiText = id => fetch(`/enterprise/batchCase/meeting/ai/record/${id}`)

/**
 * 笔录日志分页列表
 */
export const recordLogList = data => fetch('/enterprise/batchCase/meeting/recordlog/list', data, 'POST')

/**
 * 录制
 */
export const recording = id => fetch(`/enterprise/batchCase/startMCUMixTranscode/${id}`)

/**
 * 结束录制
 */
export const endRecording = id => fetch(`/enterprise/batchCase/stopMCUMixTranscode/${id}`)

